import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { HistoryOrderCard } from "../Components/HistoryOrderCard";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import { fetchOrders } from "../../Services/OrderService";

export const MyOrders = () => {
  const [loading, setLoading] = React.useState(false);
  const config = useSelector((x) => x.Config);
  const ongoingOrders = useSelector((x) => x.OngoingOrders);
  const [orders, setOrders] = React.useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  React.useEffect(() => {
    setLoading(true);
    fetchOrders({
      limit: config?.laundry_customer_maximum_order,
      offset: 1,
    }).then(
      (res) => {
        setLoading(false);
        dispatch({ type: "setOngoingOrders", payload: res.data });
      },
      (er) => {
        if (er && er.errors && er.errors.length > 0)
          er.errors.forEach((x) => toast.error(x.message));
        else toast.error("Something went wrong while fetching Ongoing Orders!");
      }
    );
  }, [config?.laundry_customer_maximum_order]);
  React.useEffect(() => {
    setOrders(ongoingOrders);
  }, [ongoingOrders]);
  return (
    <>
      <TitleHeader
        title="Ongoing Orders"
        subtitle="Below are your Ongoing Orders"
      />
      <div className="container">
        <div
          className="row flex-column align-items-center py-3"
          style={{ minHeight: "100vh" }}
        >
          {loading ? (
            <div className="col-12 text-center">
              <Spinner variant="primary" />
            </div>
          ) : orders.length > 0 ? (
            orders.map((x) => (
              <div className="col-lg-6 col-md-9 col-12 py-1">
                <HistoryOrderCard order={x} navigate={navigate} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <h4 className="text-muted text-uppercase">No Records Found!</h4>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
